var map = {
	"./en.json": [
		"./src/localization/locales/en.json"
	],
	"./nl.json": [
		"./src/localization/locales/nl.json",
		"src_localization_locales_nl_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/localization/locales lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;